const UNAVAILABLE_VALUE = 'Unavailable';

export const formatDuration = (value: string | null | undefined): string => {
  const match = value?.trim().match(/^(-?\d+):(\d{1,2})(?::\d{1,2})?$/);
  if (!match) return UNAVAILABLE_VALUE;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (!Number.isFinite(hours) || !Number.isInteger(minutes) || minutes < 0 || minutes > 59) {
    return UNAVAILABLE_VALUE;
  }

  return `${hours} hrs ${String(minutes).padStart(2, '0')} min`;
};
